var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #e0e4e9;\n      }\n\n      .cls-4 {\n        fill: #637b93;\n      }\n\n      .cls-2, .cls-5 {\n        stroke: #637b93;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 260,
    cy: 80,
    r: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 195.24,
    y1: 171.5,
    x2: 173.79,
    y2: 171.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99,171.5c0-13.13-10.64-23.77-23.77-23.77s-23.77,10.64-23.77,23.77h-13.02c-7.86,0-14.23-6.37-14.23-14.23V60.44c0-7.86,6.37-14.23,14.23-14.23h121.12c7.86,0,14.23,6.37,14.23,14.23v111.06H99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.91,115.54l-33.84-33.84c-2.67-2.67-6.29-4.17-10.06-4.17h-38.21v93.97h21.45c0-13.13,10.64-23.77,23.77-23.77s23.77,10.64,23.77,23.77h21.45v-35.83c0-7.55-3-14.79-8.34-20.12Zm-24.12,2.9l-49.36,.36v-32.65h29.44l23.31,24.27c2.88,3,.78,7.99-3.38,8.02Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 182.42,
    y1: 130.28,
    x2: 193.85,
    y2: 130.28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 75.23,
    cy: 171.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.23,155c9.1,0,16.5,7.4,16.5,16.5s-7.4,16.5-16.5,16.5-16.5-7.4-16.5-16.5,7.4-16.5,16.5-16.5m0-2c-10.22,0-18.5,8.28-18.5,18.5s8.28,18.5,18.5,18.5,18.5-8.28,18.5-18.5-8.28-18.5-18.5-18.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 219.02,
    cy: 171.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.02,155c9.1,0,16.5,7.4,16.5,16.5s-7.4,16.5-16.5,16.5-16.5-7.4-16.5-16.5,7.4-16.5,16.5-16.5m0-2c-10.22,0-18.5,8.28-18.5,18.5s8.28,18.5,18.5,18.5,18.5-8.28,18.5-18.5-8.28-18.5-18.5-18.5h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10,
    y1: 86.16,
    x2: 38.42,
    y2: 86.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.61,
    y1: 97.95,
    x2: 58.03,
    y2: 97.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.69,
    y1: 109.74,
    x2: 45.1,
    y2: 109.74
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285,62.81l-34.38,34.38-15.62-15.62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssued);
export default __webpack_public_path__ + "static/media/issued.83d4f5b3d35c55ab04ff0f8c3367e226.svg";
export { ForwardRef as ReactComponent };